import React from "react";
// import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
import { Route, Switch } from "react-router-dom";
import SubMenu from "../../components/side-nav-bar/sub-menus";
import AlumniMenuItems from "../../components/side-nav-bar/sub-menus/containers/alumni/containers/AlumniMenuItems";
import AlumniDescription from "./alumni-description/containers/AlumniDescription";
import AlumniList from "./alumni-list/AlumniList";

export enum DashboardAlumniPages {
  ALUMNI_DESCRIPTION = "/dashboard/alumni",
  ALUMNI_LIST = "/dashboard/alumni/list",
}

const AlumniRoutesAdmin = () => {
  return (
    <div className="dashboard-library-wrapper">
      <Container fluid className="course-wrapper pt-0">
        <SubMenu>
          <AlumniMenuItems />
        </SubMenu>
        <Row>
          <Col md={12} lg={12} sm={12}>
            <Switch>
              <Route exact path={DashboardAlumniPages.ALUMNI_DESCRIPTION}>
                <AlumniDescription />
              </Route>
              <Route exact path={DashboardAlumniPages.ALUMNI_LIST}>
                <AlumniList />
              </Route>
            </Switch>
          </Col>
          <Col md={3} lg={2} style={{ borderLeft: "solid 1px #333" }} />
        </Row>
      </Container>
    </div>
  );
};

export default AlumniRoutesAdmin;
